import { Component, Input, OnInit } from '@angular/core';
import { environment } from './../../../../environments/environment';

@Component({
	selector: 'app-cig-there-are-no-bad-scores',
	templateUrl: './cig-there-are-no-bad-scores.component.html',
	styleUrls: ['./cig-there-are-no-bad-scores.component.scss']
})
export class CigThereAreNoBadScoresComponent implements OnInit {

	@Input() author;
	@Input() slides;
	public env;

	constructor() { }

	ngOnInit() {
		this.env=environment;
	}

}
